export default "__VITE_ASSET__CLBBlJ70__"